// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const LayoutApprovals = () => {
//   const [approvalName, setApprovalName] = useState("");
//   const [approvals, setApprovals] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // ✅ GET API
//   const fetchApprovals = async () => {
//     try {
//       setLoading(true);

//       const response = await axios.get(
//         "https://api.propertygalleria.in/master/api/api/layout-approvals"
//       );

//       if (response.data.success) {
//         setApprovals(response.data.data);
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//       alert("Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ POST API
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!approvalName.trim()) {
//       alert("Please enter approval name");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "https://api.propertygalleria.in/master/api/api/layout-approvals",
//         {
//           approval_name: approvalName,
//         }
//       );

//       if (response.data.success) {
//         alert("Approval Added Successfully");

//         setApprovalName("");

//         // Refresh table
//         fetchApprovals();
//       }
//     } catch (error) {
//       console.error("Post Error:", error);
//       alert("Failed to save data");
//     }
//   };

//   useEffect(() => {
//     fetchApprovals();
//   }, []);

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <h2 style={styles.heading}>Layout Approvals</h2>

//         {/* ✅ Form */}
//         <form onSubmit={handleSubmit} style={styles.form}>
//           <input
//             type="text"
//             placeholder="Enter Approval Name"
//             value={approvalName}
//             onChange={(e) => setApprovalName(e.target.value)}
//             style={styles.input}
//           />

//           <button type="submit" style={styles.button}>
//             Submit
//           </button>
//         </form>

//         {/* ✅ Table */}
//         <div style={styles.tableWrapper}>
//           {loading ? (
//             <p>Loading...</p>
//           ) : (
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>ID</th>
//                   <th style={styles.th}>Approval Name</th>
//                   <th style={styles.th}>Created At</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {approvals.length > 0 ? (
//                   approvals.map((item) => (
//                     <tr key={item.id}>
//                       <td style={styles.td}>{item.id}</td>
//                       <td style={styles.td}>{item.approval_name}</td>
//                       <td style={styles.td}>
//                         {new Date(item.created_at).toLocaleString()}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" style={styles.noData}>
//                       No Data Found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LayoutApprovals;

// const styles = {
//   container: {
//     padding: "30px",
//     backgroundColor: "#f4f7fb",
//     minHeight: "100vh",
//   },

//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     padding: "25px",
//     boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//   },

//   heading: {
//     marginBottom: "20px",
//     color: "#222",
//   },

//   form: {
//     display: "flex",
//     gap: "15px",
//     marginBottom: "25px",
//     flexWrap: "wrap",
//   },

//   input: {
//     flex: 1,
//     minWidth: "250px",
//     padding: "12px",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     fontSize: "14px",
//     outline: "none",
//   },

//   button: {
//     backgroundColor: "#2563eb",
//     color: "#fff",
//     border: "none",
//     padding: "12px 24px",
//     borderRadius: "8px",
//     cursor: "pointer",
//     fontWeight: "bold",
//   },

//   tableWrapper: {
//     overflowX: "auto",
//   },

//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//   },

//   th: {
//     backgroundColor: "#2563eb",
//     color: "#fff",
//     padding: "12px",
//     textAlign: "left",
//   },

//   td: {
//     padding: "12px",
//     borderBottom: "1px solid #ddd",
//   },

//   noData: {
//     textAlign: "center",
//     padding: "20px",
//   },
// };

import React, { useEffect, useState } from "react";
import axios from "axios";

const LayoutApprovals = () => {
  const [approvalName, setApprovalName] = useState("");
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ GET API
  const fetchApprovals = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        "https://api.propertygalleria.in/master/api/api/layout-approvals"
      );

      if (response.data.success) {
        setApprovals(response.data.data);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      alert("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // ✅ POST API
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!approvalName.trim()) {
      alert("Please enter approval name");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.propertygalleria.in/master/api/api/layout-approvals",
        {
          approval_name: approvalName,
        }
      );

      if (response.data.success) {
        alert("Approval Added Successfully");

        setApprovalName("");

        // ✅ Refresh Table
        fetchApprovals();
      }
    } catch (error) {
      console.error("Post Error:", error);
      alert("Failed to save data");
    }
  };

  // ✅ DELETE API
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete?"
    );

    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `https://api.propertygalleria.in/master/api/api/layout-approvals/${id}`
      );

      if (response.data.success) {
        alert("Deleted Successfully");

        // ✅ Refresh Table
        fetchApprovals();
      }
    } catch (error) {
      console.error("Delete Error:", error);
      alert("Failed to delete data");
    }
  };

  useEffect(() => {
    fetchApprovals();
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Layout Approvals</h2>

        {/* ✅ Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Enter Approval Name"
            value={approvalName}
            onChange={(e) => setApprovalName(e.target.value)}
            style={styles.input}
          />

          <button type="submit" style={styles.button}>
            Submit
          </button>
        </form>

        {/* ✅ Table */}
        <div style={styles.tableWrapper}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Approval Name</th>
                  <th style={styles.th}>Created At</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {approvals.length > 0 ? (
                  approvals.map((item) => (
                    <tr key={item.id}>
                      <td style={styles.td}>{item.id}</td>

                      <td style={styles.td}>
                        {item.approval_name}
                      </td>

                      <td style={styles.td}>
                        {new Date(
                          item.created_at
                        ).toLocaleString()}
                      </td>

                      <td style={styles.td}>
                        <button
                          style={styles.deleteButton}
                          onClick={() =>
                            handleDelete(item.id)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={styles.noData}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default LayoutApprovals;

const styles = {
  container: {
    padding: "30px",
    backgroundColor: "#f4f7fb",
    minHeight: "100vh",
  },

  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "25px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },

  heading: {
    marginBottom: "20px",
    color: "#222",
  },

  form: {
    display: "flex",
    gap: "15px",
    marginBottom: "25px",
    flexWrap: "wrap",
  },

  input: {
    flex: 1,
    minWidth: "250px",
    padding: "12px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
  },

  button: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  deleteButton: {
    backgroundColor: "#dc2626",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  tableWrapper: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "12px",
    textAlign: "left",
  },

  td: {
    padding: "12px",
    borderBottom: "1px solid #ddd",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
  },
};